import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "../errorMessage";
import Validator from "../validator";

export enum NumberOfDamagesInLastThreeYearsId {
    zero = "ZERO",
    one = "ONE",
    two = "TWO",
    threeOrMore = "THREE_OR_MORE"
}

export interface NumberOfDamagesInLastThreeYearsModel {
    value: NumberOfDamagesInLastThreeYearsId | undefined;
    errorMessage: string;
    editable: boolean;

    validateNumberOfDamagesInLastThreeYears: () => void;
}

export class DefaultNumberOfDamagesInLastThreeYears implements NumberOfDamagesInLastThreeYearsModel {
    @observable value: NumberOfDamagesInLastThreeYearsId | undefined;
    @observable errorMessage: string;
    @observable editable: boolean;

    constructor(value: NumberOfDamagesInLastThreeYearsId | undefined, editable: boolean = true) {
        makeObservable(this);

        this.value = value;
        this.errorMessage = "";
        this.editable = editable;
    }

    @action
    public validateNumberOfDamagesInLastThreeYears = () => {
        if (!Validator.inNotNullOrUndefined(this.value!)) {
            this.errorMessage = ErrorMessages.required;
        } else {
            this.errorMessage = "";
        }
    }
}
